import React from 'react'
import { useSelector } from 'react-redux';
import { selectQualityAlertFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import QualityAlertSearch from './quality-alert-search';
import QualityAlertFilter from './quality-alert-filter';
import QualityAlertTile from './quality-alert-tile';
import QualityAlertTable from './quality-alert-table';

const QualityAlertContent = props => {
    const isFilterVisible = useSelector(selectQualityAlertFilterVisible); // Use the selector
    const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
    <div className="card-body">
      <div className="table-top">
        <QualityAlertSearch />
      </div>
      {isFilterVisible && <QualityAlertFilter />}

      {!showTileView ? <QualityAlertTile /> : <QualityAlertTable />}
    </div>
  </div>
);
};

export default QualityAlertContent